/* istanbul ignore next */
(function(angular) {
  'use strict';

  /**
   * This function creates a fully functional MFE routing configuration based on <mfe-loader></mfe-loader>.
   * @param {Object} $stateProvider - angular.js $stateProvider
   * @param {Object} $urlRouterProvider - angular.js $urlRouterProvider
   * @param {String} name - angular.js UI Router state name
   * @param {String} base - Base path for the MFE routing (example: /preview/setup). It MUST NOT end with /
   * @param {String} moduleName - NPM name of the module that contains the MFE`
   * @param {Object} permission - Optional permission to resolve using angular.js UI Router resolves to prevent loading of the MFE
   * @param {Boolean} enableBento - Add 'ng-bento' css class
   * @param {Boolean} customClass - Add customClass to css class
   */
  function createMFERoute($stateProvider, $urlRouterProvider, name, base, moduleName, permission, enableBento, customClass) {
    $urlRouterProvider.when(`${base}`, `${base}/`);
    let isRouteReloading = false;
    let cachedNode;
    $stateProvider.state(name, {
      url: `${base}/{path:.*}`,
      template: `<${name}-fake-view-placeholder></${name}-fake-view-placeholder>`,
      reloadOnSearch: false,
      controller: ['$state', '$scope', function($state, $scope) {

        this.$onInit = function() {
          if (!cachedNode) {
            cachedNode = document.createElement('mfe-loader');
            cachedNode.setAttribute('module-name', moduleName);

            if (enableBento) {
              cachedNode.classList.add('ng-bento');
            }

            if (customClass) {
              cachedNode.classList.add(customClass);
            }
          }

          if (cachedNode) {
            cachedNode.preventUnmount = isRouteReloading;
            document.querySelector(`${name}-fake-view-placeholder`).replaceWith(cachedNode);
            cachedNode.preventUnmount = false;
          }
          isRouteReloading = false;
          cachedNode.removeAllListeners('mfe-route-change');
          cachedNode.addEventListener('mfe-route-change', function(event) {
            if ($state.params.path !== event.detail.replace(`${base}/`, '')) {
              isRouteReloading = true;
              $state.transitionTo(name, { path: event.detail.replace(`${base}/`, '') }, {
                inherit: true,
                location: true,
                reload: false,
                notify: true,
              });
            }
          });
        };

        const stopListening = $scope.$on('$destroy', function() {
          cachedNode.preventUnmount = isRouteReloading;
          cachedNode.removeAllListeners('mfe-route-change');
          if (!isRouteReloading) {
            cachedNode = undefined;
          }
          stopListening();
        });
      }],
      resolve: {
        permission
      },
    });
  }

  // Do NOT access anything in here directly. This
  // is only here to help intellisense find types.
  // Instead, access items using angular injection.
  window.practice = {
    services: {},
    models: {},
    views: {},
    directives: {},
    mixins: {},
    /// <field name="misc" type="Object">Various unsorted types.</field>
    misc: {
      entityTypes: {}
    }
  };

  // root redirect and catch-all routing
  angular.module('core').config(['$stateProvider', '$urlRouterProvider',
    function($stateProvider, $urlRouterProvider) {

      // root redirection and
      //Pull query paramater 'name' from the url
      //Found here: https://medium.com/@melwinalm/everything-about-query-parameters-in-javascript-also-urlsearchparams-1719fbc4f3b4
      var getParameterByName = function(url, name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);
        if (results === null) {
          return null;
        }
        return decodeURI(results[1]);
      };

      $urlRouterProvider.when('', function() {
        //Grabs the paramaters from the url for state, code and realmId
        var state = getParameterByName(window.location.href, 'state');
        var code = getParameterByName(window.location.href, 'code');
        var realmId = getParameterByName(window.location.href, 'realmId');

        if (state !== null && code !== null && realmId !== null) {
          return '/qbo-callback?state=' + state + '&code=' + code + '&realmId=' + realmId;
        } else {
          return '/';
        }
      });

      // todo: redirect to first nav item you have access to
      $urlRouterProvider.when(/^(\s*|\/)$/, '/');

      // not found
      $stateProvider.state('notfound', {
        url: '/notfound',
        templateUrl: 'views/not-found/not-found.html'
      });

      // not found
      $stateProvider.state('qboCallback', {
        url: '/qbo-callback',
        templateUrl: 'quick-books-integration-callback/quick-books-integration-callback.2js.html'
      });

      // loopback route
      $stateProvider.state('loopback', {
        url: '/loopback?path',
        controller: 'AuthLoopbackController'
      });

      /**
       * Micro front end routing
       */

      createMFERoute($stateProvider, $urlRouterProvider, 'setup-preview', '/preview/setup', '@onviobr/staff-setup', ['$state', 'bmAccess', 'bmPermission', function($state, bmAccess, bmPermission) {
        bmAccess.has('HideFERebuild_ActivityCategories').then(function() {
          bmPermission.has('MigrationDashboard.NewExperience').then(angular.noop).catch(function() {
            $state.go('notfound', {}, { location: 'replace' });
          });
        }).catch(angular.noop);
      }], false);

      createMFERoute($stateProvider, $urlRouterProvider, 'projects-preview', '/preview/projects', '@onvio/projects', ['$state', 'bmAccess', function($state, bmAccess) {
        bmAccess.has('HideFERebuild_ActivityCategories').then(function() {
          $state.go('notfound', {}, { location: 'replace' });
        }).catch(angular.noop);
      }], false);

      createMFERoute($stateProvider, $urlRouterProvider, 'br-permissions-group', '/br/permissions-group', '@onviobr/permissions-group', ['$state', 'bmAccess', 'bmLicense', function($state, bmAccess, bmLicense) {
        bmAccess.not(['Brazil_NewStaffPermissionDesign'], true).then(function() {
          bmLicense.not('OnvioBR.PermissionsGroup').then(function() {
            $state.go('notfound', {}, { location: 'replace' });
          });
        }).catch(angular.noop);
      }], false, 'brazil-mfe-container');

      createMFERoute($stateProvider, $urlRouterProvider, 'br-company-staff', '/br/company-staff', '@onviobr/company-staff', ['$state', 'bmAccess', 'bmLicense', function($state, bmAccess, bmLicense) {
        bmAccess.not(['Brazil_NewStaffPermissionDesign'], true).then(function() {
          bmLicense.not('OnvioBR.PermissionsGroup').then(function() {
            $state.go('notfound', {}, { location: 'replace' });
          });
        }).catch(angular.noop);
      }], false, 'brazil-mfe-container');

      createMFERoute($stateProvider, $urlRouterProvider, 'br-default-department', '/setup/br-departments', '@onviobr/br-default-department', ['$state', 'bmAccess', 'bmPermission', function($state, bmAccess, bmPermission) {
        bmPermission.has('OnvioSetup.Departments', true).then(function() {
          bmAccess.not('BR_EnableBRDepartments', true).then(function() {
            bmPermission.not('OnvioBR.EnableBRDepartments').then(function() {
              $state.go('notfound', {}, { location: 'replace' });
            }).catch(angular.noop);
          }).catch(angular.noop);
        }).catch(function() {
          $state.go('notfound', {}, { location: 'replace' });
        });
      }], true);

      // catch-all -> not found
      $urlRouterProvider.otherwise('/notfound');
    }
  ]);

  angular.module('core');

}(window.angular));
